import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-claim-creation',
  templateUrl: './claim-creation.component.html',
  styleUrls: ['./claim-creation.component.scss']
})
export class ClaimCreationComponent implements OnInit {

  constructor(public global: GlobalComponent) { }

  ngOnInit(): void {
  }

}
